<template>
  <b-card v-if="!!option" id="page-service-form" no-body class="mb-0">
    <b-card-header>
      <b-card-title>
        <h2>
          {{ $t(getTitle()) }} {{ $t("pages.services.title").toLowerCase() }}
        </h2>
      </b-card-title>
      <b-button variant="primary" @click="goBack">
        <feather-icon icon="ArrowLeftIcon" />
        {{ $t("back") }}
      </b-button>
    </b-card-header>

    <b-card-body>
      <form-wizard
        ref="form"
        color="#44b8ff"
        :title="null"
        :subtitle="null"
        shape="square"
        class="mb-3 shadow-none"
      >
        <!-- Datos del servicio -->
        <tab-content
          :title="$t('pages.services.title')"
          :before-change="validationServiceTab"
          ref="formDataService"
        >
          <validation-observer ref="serviceRules" tag="form">
            <b-form>
              <b-row>
                <!-- nombre -->
                <b-col cols="12" md="6">
                  <b-form-group :label="$t(label('name'))" label-for="name">
                    <validation-provider
                      #default="{ errors }"
                      :name="$t(label('name'))"
                      rules="required"
                    >
                      <b-form-input
                        id="name"
                        v-model="service.name"
                        :disabled="option === 2 ? true : false"
                        :placeholder="$t(label('name'))"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <!-- precio -->
                <b-col cols="12" md="6">
                  <b-form-group :label="$t(label('price'))" label-for="price">
                    <validation-provider
                      #default="{ errors }"
                      :name="$t(label('price'))"
                      rules="required"
                    >
                      <b-input-group
                        :prepend="divisa"
                        append=".00"
                        class="input-group-merge"
                      >
                        <b-form-input
                          id="price"
                          type="number"
                          v-model="service.price"
                          :disabled="option === 2 ? true : false"
                          :placeholder="$t(label('price'))"
                      /></b-input-group>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <!-- tipo de duracion -->
                <b-col cols="12" md="6">
                  <validation-provider
                    #default="{ errors }"
                    :name="$t(label('typeDuration'))"
                    rules="required"
                  >
                    <b-form-group
                      :label="$t(label('typeDuration'))"
                      label-for="typeDuration"
                      :state="errors.length > 0 ? false : null"
                    >
                      <v-select
                        input-id="typeDuration"
                        v-model="service.idCatCategory"
                        :options="durations"
                        label="name"
                        :placeholder="$t(label('typeDuration'))"
                        :disabled="!isSaveMode"
                        :reduce="(option) => option"
                      >
                        <span slot="no-options">{{ $t("sorryOption") }}</span>
                      </v-select>
                      <b-form-invalid-feedback
                        :state="errors.length > 0 ? false : null"
                      >
                        {{ errors[0] }}
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>
                </b-col>
                <!-- duracion -->
                <b-col cols="12" md="6">
                  <b-form-group
                    :label="$t(label('duration'))"
                    label-for="duration"
                  >
                    <validation-provider
                      #default="{ errors }"
                      :name="$t(label('duration'))"
                      rules="required"
                    >
                      <b-form-input
                        id="duration"
                        type="number"
                        v-model="service.durationMinutes"
                        :disabled="option === 2 ? true : false"
                        :placeholder="$t(label('duration'))"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <!-- Máximo de citas permitidas -->
                <b-col cols="12" md="6">
                  <b-form-group
                    :label="$t(label('maxAppointment'))"
                    label-for="maxAppointments"
                  >
                    <b-form-input
                      id="maxAppointments"
                      type="number"
                      v-model="service.maxAppointmentsPerSlot"
                      :disabled="option === 2 ? true : false"
                      :placeholder="$t(label('maxAppointment'))"
                    />
                  </b-form-group>
                </b-col>
                <!-- Tiempo de espera entre citas -->
                <b-col cols="12" md="6">
                  <b-form-group
                    :label="$t(label('timeOffAppointment'))"
                    label-for="bufferTimeBetween"
                  >
                    <b-form-input
                      id="bufferTimeBetween"
                      type="number"
                      v-model="service.bufferTimeBetweenAppointments"
                      :disabled="option === 2 ? true : false"
                      :placeholder="$t(label('timeOffAppointment'))"
                    />
                  </b-form-group>
                </b-col>
                <!-- Empleado -->
                <b-col cols="12" md="6">
                  <validation-provider
                    #default="{ errors }"
                    :name="$t(label('employees'))"
                    rules="required"
                  >
                    <b-form-group
                      :label="$t(label('employees'))"
                      label-for="employees"
                      :state="errors.length > 0 ? false : null"
                    >
                      <v-select
                        v-model="service.employees"
                        input-id="employees"
                        :options="allEmployees"
                        label="name"
                        :placeholder="$t(label('employees'))"
                        :disabled="!isSaveMode"
                        :reduce="(option) => option.idEmployee"
                        @option:selecting="onSelecting"
                        @input="onInput"
                        @option:selected="onSelected"
                        multiple
                      >
                        <span slot="no-options">{{ $t("sorryOption") }}</span>
                      </v-select>
                      <b-form-invalid-feedback
                        :state="errors.length > 0 ? false : null"
                      >
                        {{ errors[0] }}
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>
                </b-col>
                <b-col cols="12" md="6">
                  <b-form-group :label="$t(label('generateAppointment'))">
                    <b-form-radio-group
                      v-model="service.generateAppointment"
                      :options="listGenerateAppointment"
                      :disabled="!isSaveMode"
                    ></b-form-radio-group>
                  </b-form-group>
                </b-col>
                <b-col cols="12" md="6">
                  <b-form-group
                    :label="$t(label('description'))"
                    label-for="description"
                  >
                    <validation-provider
                      #default="{ errors }"
                      :name="$t(label('description'))"
                      rules="required"
                    >
                      <b-form-textarea
                        id="description"
                        v-model="service.description"
                        :placeholder="$t(label('description'))"
                        :disabled="!isSaveMode"
                        rows="8"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>

                <b-col cols="12" md="6">
                  <b-form-group
                    :label="$t(label('details'))"
                    label-for="details"
                  >
                    <validation-provider
                      #default="{ errors }"
                      :name="$t(label('details'))"
                      rules="required"
                    >
                      <b-form-textarea
                        id="details"
                        v-model="service.details"
                        :placeholder="$t(label('details'))"
                        :disabled="!isSaveMode"
                        rows="8"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-form>
          </validation-observer>
        </tab-content>

        <tab-content :title="$t('pages.products.photos')" ref="formList">
          <b-row>
            <b-col v-if="option != 2" cols="12" sm="6">
              <b-media class="body-style">
                <div>
                  <input
                    id="inputFilePhoto"
                    ref="fileInputPhoto"
                    name="inputFilePhoto"
                    type="file"
                    class="hidden"
                    accept=".png,.peg,.jpg,.jpeg"
                    @change="onFileChange($event, 'photos')"
                  />
                  <div
                    class="cursor-pointer m-auto cuve text-center border-2 d-flex align-items-center justify-content-center"
                    accept=".png,.peg,.jpg,.jpeg"
                    @drop="handleDrop($event, 'photos')"
                    @dragover="handleDragover"
                    @dragenter="handleDragover"
                    @click="$refs.fileInputPhoto.click()"
                  >
                    <feather-icon
                      icon="UploadCloudIcon"
                      size="20"
                      svg-classes="h-16 w-16 stroke-current text-grey"
                    />
                    <span
                      style="margin-left: 5px"
                      @click.stop="$refs.fileInputPhoto.click()"
                      >Subir imagen
                    </span>
                  </div>
                </div>
              </b-media>
            </b-col>
            <!-- <pre>{{ service }}</pre> -->
            <b-col
              v-for="(item, index) in service.photos"
              :key="index"
              cols="12"
              sm="12"
              md="12"
              lg="6"
              xl="6"
              class="d-flex justify-content-center"
            >
              <b-media class="body-style">
                <template #aside>
                  <img
                    id="image"
                    ref="image"
                    :src="item.urlPhoto"
                    class="img-avatar border-dashed"
                  />
                </template>
                <div
                  v-if="service.photos && option != 2"
                  class="d-flex flex-wrap"
                  style="width: 10px"
                >
                  <b-button
                    variant="primary"
                    style="height: 30px; width: 30px; padding: 4px"
                    @click="deleteFile(item, index)"
                  >
                    <feather-icon icon="XIcon" size="21" />
                  </b-button>
                </div>
              </b-media>
            </b-col>
          </b-row>
        </tab-content>

        <template slot="footer" slot-scope="props">
          <div class="wizard-footer-left">
            <wizard-button
              v-if="props.activeTabIndex > 0 && !props.isLastStep"
              @click.native="props.prevTab()"
              :style="props.fillButtonStyle"
            >
              {{ $t("back") }}
            </wizard-button>

            <wizard-button
              v-else-if="props.activeTabIndex > 0 && props.isLastStep"
              @click.native="props.prevTab()"
              :style="props.fillButtonStyle"
            >
              {{ $t("back") }}
            </wizard-button>
          </div>
          <div class="wizard-footer-right">
            <wizard-button
              v-if="!props.isLastStep"
              @click.native="props.nextTab()"
              class="wizard-footer-right"
              :style="props.fillButtonStyle"
            >
              {{ $t("following") }}
            </wizard-button>

            <wizard-button
              v-else-if="option != 2"
              @click.native="onSubmit"
              class="wizard-footer-right finish-button"
              :style="props.fillButtonStyle"
            >
              {{ props.isLastStep ? $t("save") : $t("following") }}
            </wizard-button>
          </div>
        </template>
      </form-wizard>
    </b-card-body>
  </b-card>
</template>

<script>
import _ from "lodash";
import moment from "moment";
import { FormWizard, TabContent, WizardButton } from "vue-form-wizard";
import { ValidationProvider, ValidationObserver, localize } from "vee-validate";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import {
  BInputGroup,
  BCard,
  BCardHeader,
  BCardTitle,
  BCardBody,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BFormGroup,
  BFormCheckbox,
  BForm,
  BFormTextarea,
  BAlert,
  BFormSelect,
  BModal,
  BToast,
  BFormRadio,
  BFormRadioGroup,
  BFormInvalidFeedback,
  BFormFile,
} from "bootstrap-vue";
import router from "@/router";
import Ripple from "vue-ripple-directive";
import { required, integer } from "@validations";
import vSelect from "vue-select";

import { getService, createOrEditService } from "@core/api/request/services";
import { getCatalog } from "@core/api/request/catalogs";

import { getParams, showLoading, stopLoading } from "@core/utils/utils";
import { postFile } from "@core/api/request/catalogs";
import { allEmployeesByCompany } from "@core/api/request/employees";

const service = {
  guid: "",
  guidCompany: "",
  name: "",
  description: "",
  details: "",
  price: 0,
  idCatCategory: null,
  durationMinutes: 0,
  generateAppointment: true,
  maxAppointmentsPerSlot: 0,
  bufferTimeBetweenAppointments: 0,
  photos: [],
  employees: [],
};

export default {
  components: {
    BInputGroup,
    FormWizard,
    TabContent,
    WizardButton,
    BFormInvalidFeedback,
    BFormRadio,
    BFormRadioGroup,
    BAlert,
    BModal,
    ValidationProvider,
    ValidationObserver,
    BCard,
    BCardHeader,
    BCardTitle,
    BCardBody,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BForm,
    vSelect,
    BFormTextarea,
    BFormSelect,
    BToast,
    BFormFile,
  },
  directives: {
    Ripple,
  },
  data: () => ({
    isSaveMode: true,
    itemSelected: null,
    required,
    service: Object.assign(service),
    option: "",
    guidCompany: "",
    durations: [],
    listGenerateAppointment: [
      { text: "Sí", value: true },
      { text: "No", value: false },
    ],
    allEmployees: [],
  }),
  computed: {
    canNavigateWizardFreely() {
      return this.option === 2 || this.option === 3;
    },
    divisa() {
      return this.$store.state.appConfig.divisa || "USD";
    },
  },
  watch: {
    "$store.state.appConfig.activeCompanyGuid"(guid) {
      this.guidCompany = guid;
      if (this.guidCompany) {
        this.loadEmployees();
      }
    },
  },
  created() {
    this.guidCompany = this.$store.state.appConfig.activeCompanyGuid;
    localize("es");
    this.initialize();
  },
  mounted() {
    console.log("guid->", this.guidCompany);
    this.enableWizardFreeNavigation();
  },
  methods: {
    async initialize() {
      this.option = this.$route.params.option || "";
      console.log("Option->", this.option);
      if (!this.option) {
        this.$router.push({ name: "services" });
        return;
      }
      this.onCancel();
      switch (this.option) {
        case 1:
          await Promise.all([this.loadCatData(), this.loadEmployees()]);
          break;
        case 2:
        case 3:
          if (this.$route.params.guid === undefined) {
            this.$router.push({ name: "services" });
          }
          this.isSaveMode = this.option !== 2;
          await Promise.all([
            this.loadCatData(),
            this.loadEmployees(),
            this.getService(this.$route.params.guid),
          ]);
          this.enableWizardFreeNavigation();
          break;
      }
    },
    enableWizardFreeNavigation() {
      if (!this.canNavigateWizardFreely) return;

      this.$nextTick(() => {
        if (this.$refs.form && this.$refs.form.activateAll) {
          this.$refs.form.activateAll();
        }
      });
    },
    async getService(guid) {
      showLoading();
      let employees = [];
      try {
        await getService(guid)
          .then((resp) => {
            const service = _.get(resp, "data");
            console.log("ResponseAPI->", service);
            if (service.employees.length > 0) {
              employees = service.employees.map((employee) => ({
                idEmployee: employee.idEmployee,
                name: employee.employee.name,
              }));
            }
            console.log("employees", employees);

            const body = {
              guid: service.guid || "",
              name: service.name || "",
              description: service.description || "",
              details: service.details || "",
              price: service.price || 0,
              idCatCategory:
                this.showDurationType(service.idCatCategory) || null,
              durationMinutes: service.durationMinutes || null,
              generateAppointment: service.generateAppointment ? true : false,
              maxAppointmentsPerSlot: service.maxAppointmentsPerSlot || null,
              bufferTimeBetweenAppointments:
                service.bufferTimeBetweenAppointments || null,
              employees: employees,
              photos:
                service.photos.map((photo) => ({ urlPhoto: photo.urlPhoto })) ||
                [],
            };
            this.service = body;
            stopLoading();
          })
          .catch((error) => {
            console.log("error", error.message);
            stopLoading();
            this.alertToast(
              "danger",
              "Error",
              error.message,
              "AlertTriangleIcon",
            );
          });
      } catch (error) {
        console.log("error", error.message);
        stopLoading();
        this.alertToast("danger", "Error", error.message, "AlertTriangleIcon");
      }
    },
    async loadCatData() {
      try {
        const arrParams = getParams([
          `itemsPage,1`,
          `itemsRows,999`,
          `guidCatalog, 2ba8b287-5338-447a-8684-fc40fe505328`,
        ]);
        await getCatalog(arrParams)
          .then((resp) => {
            const data = _.get(resp, "data.listOfItems.items") || [];
            this.durations = data.map((duration) => {
              return {
                id: duration.id,
                name: duration.name,
              };
            });
          })
          .catch((error) => {
            console.log("error", error.message);
            this.alertToast(
              "danger",
              "Error",
              error.message,
              "AlertTriangleIcon",
            );
          });
      } catch (error) {
        console.log("error", error.message);
        this.alertToast("danger", "Error", error.message, "AlertTriangleIcon");
      }
    },
    async loadEmployees() {
      showLoading();
      try {
        const arrParams = getParams([
          `page,1`,
          `rows,999`,
          `guidCompany,${this.guidCompany}`,
          "active,true",
        ]);
        await allEmployeesByCompany(arrParams)
          .then((resp) => {
            stopLoading();
            const employees = _.get(resp, "data.items") || [];
            this.allEmployees = employees;
            console.log("employees", this.allEmployees);
          })
          .catch((error) => {
            console.log("error", error.message);
            stopLoading();
            this.alertToast(
              "danger",
              "Error",
              error.message,
              "AlertTriangleIcon",
            );
          });
      } catch (error) {
        console.log("error", error.message);
        stopLoading();
        this.alertToast("danger", "Error", error.message, "AlertTriangleIcon");
      }
    },

    onSubmit() {
      this.$refs.serviceRules.validate().then((success) => {
        if (success) {
          showLoading();
          try {
            let employees = this.service.employees.map((employee) => ({
              idEmployee:
                typeof employee == "object" ? employee.idEmployee : employee,
            }));
            const data = {
              guid: this.service.guid,
              name: this.service.name,
              description: this.service.description,
              details: this.service.details,
              price: this.service.price,
              idCatCategory: this.service.idCatCategory.id,
              durationMinutes: parseInt(this.service.durationMinutes),
              generateAppointment: this.service.generateAppointment,
              maxAppointmentsPerSlot: parseInt(
                this.service.maxAppointmentsPerSlot,
              ),
              bufferTimeBetweenAppointments: parseInt(
                this.service.bufferTimeBetweenAppointments,
              ),
              photos: this.service.photos,
              employees: employees,
            };

            const services = [];
            services.push(data);

            const service = {
              services: services,
              guidCompany: this.guidCompany,
            };
            const guid = this.option === 1 ? null : this.service.guid;
            createOrEditService(this.option === 1 ? service : data, guid)
              .then((resp) => {
                this.alertToast(
                  "success",
                  this.$t("Alert"),
                  `${
                    this.option != 3
                      ? this.$t("registerSuccess")
                      : this.$t("updateRecord")
                  }`,
                  "CheckIcon",
                );
                stopLoading();
                this.goBack();
              })
              .catch((error) => {
                stopLoading();
                this.alertToast(
                  "danger",
                  "Error",
                  error.message,
                  "AlertTriangleIcon",
                );
              });
          } catch (error) {
            stopLoading();
            this.alertToast(
              "danger",
              "Error",
              error.message,
              "AlertTriangleIcon",
            );
          }
        }
      });
    },
    label(field) {
      return `pages.services.form.label.${field}`;
    },
    getTitle() {
      if (this.option === 1) return "register";
      else if (this.option === 2) return "show";
      else if (this.option === 3) return "edit";
    },
    showDurationType(value) {
      if (value == 43) {
        return { id: 43, name: "Días", color: null };
      } else if (value == 44) {
        return { id: 44, name: "Minutos", color: null };
      } else {
        return { id: 45, name: "Horas", color: null };
      }
    },
    goBack() {
      this.$refs.serviceRules.reset();
      router.back();
    },

    onCancel() {
      this.service = Object.assign({
        guid: null,
        guidCompany: null,
        name: "",
        description: "",
        details: "",
        price: 0,
        idCatCategory: 0,
        durationMinutes: 0,
        generateAppointment: true,
        maxAppointmentsPerSlot: 0,
        bufferTimeBetweenAppointments: 0,
        photos: [],
      });
    },

    message(title, text, icon) {
      this.$swal({
        title,
        text,
        icon,
        customClass: {
          confirmButton: "btn btn-success",
        },
      });
    },

    alertToast(type = null, title = null, message = null) {
      this.$bvToast.toast(message, {
        title,
        variant: type,
        solid: true,
        icon: "CoffeeIcon",
      });
    },

    // STEPER ASOCIATION
    validationService() {
      return new Promise((resolve, reject) => {
        this.$refs.serviceRules.validate().then((success) => {
          if (success) {
            resolve(true);
          } else {
            reject();
          }
        });
      });
    },

    validationServiceTab() {
      if (this.canNavigateWizardFreely) return true;

      return this.validationService();
    },

    onFileChange(e, field) {
      if (e?.target?.files?.length > 0) {
        this.onTransFile(
          e?.target?.files,
          e.target.accept,
          e.target.multiple,
          field,
        );
      }
    },

    handleDragover(e) {
      e.stopPropagation();
      e.preventDefault();
      e.dataTransfer.dropEffect = "copy";
    },

    handleDrop(e, field) {
      e.stopPropagation();
      e.preventDefault();
      const { files } = e.dataTransfer;
      if (files.length !== 1) {
        return;
      }
      const accept =
        e.target.getAttribute("accept") ||
        e.target.parentElement.getAttribute("accept");
      const multiple =
        e.target.getAttribute("multiple") ||
        e.target.parentElement.getAttribute("multiple");
      this.onTransFile(files, accept, multiple, field);
    },

    onTransFile(files, accept, multiple, field) {
      try {
        if (!multiple) {
          files.forEach((file) => {
            if (file) {
              const type = file.type.split("/").pop();
              if (file && accept.split(",").indexOf(`.${type}`) > -1) {
                showLoading();
                postFile(file)
                  .then((resp) => {
                    stopLoading();
                    this.service.photos.push({
                      urlPhoto: resp.data,
                    });
                  })
                  .catch((error) => {
                    stopLoading();
                  });
              }
            }
          });
        }
      } catch (error) {
        console.error(error);
      }
    },

    deleteFile(item, index) {
      this.service.photos = _.reject(this.service.photos, {
        urlPhoto: item.urlPhoto,
      });
    },

    onSelecting(value) {
      console.log("About to selecting:", value);
      this.itemSelected = value.idEmployee;
    },
    onInput(newSelection) {
      console.log("value->", newSelection);
      console.log(this.itemSelected);
    },
    onSelected(value) {
      console.log("About to select:", value);
      const blocked = value.filter(
        (opt) => opt.idEmployee === this.itemSelected,
      );
      if (blocked.length > 1) {
        // Remove Option 2 from selection
        this.service.employees.pop();
        this.service.employees = [...this.service.employees];
      }
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "../../../../public/loader.css";
@import "~@core/scss/vue/libs/vue-wizard.scss";
</style>
